import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../App.css';

function AboutMe() {
  const { t } = useTranslation();

  return (
    <section id="about" style={{ padding: 'var(--section-spacing) 0' }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <h2 className="section-title">{t('about_me')}</h2>
            <p style={{
              fontSize: '1.2rem',
              color: 'var(--text-secondary)',
              lineHeight: '1.8',
              marginBottom: '2rem'
            }}>
              {t('about_intro')}
            </p>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>
              {t('learn_more_text')}
            </p>
            <a href="resume.pdf" target="_blank" className="btn" style={{
              background: 'transparent',
              color: 'var(--accent-primary)',
              padding: '12px 30px',
              borderRadius: '50px',
              fontWeight: '600',
              border: '1px solid var(--accent-primary)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              transition: 'all 0.3s ease'
            }}>
              <i className="fas fa-file-pdf"></i> {t('resume')}
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutMe;
